import { type ReactNode, useEffect } from 'react'
import { NotReady } from '@components'
import { useProfile } from '@front/model'
import { useNavigate, useRouter, createFileRoute } from '@tanstack/react-router'
import { isSunrun } from '@terros/common'
import { OktaUserSearch } from './OktaUserSearch'

function SunrunOktaUsersPage(): ReactNode {
  const { user, isLoading, error } = useProfile()
  const router = useRouter()

  const navigate = useNavigate()
  useEffect(() => {
    if (!isLoading && !isSunrun(user?.companyId)) {
      router.history.back()
    }
  }, [user, isLoading, navigate])

  if (!user || isLoading || error) return <NotReady data={user} error={error} isLoading={isLoading} />

  if (!isSunrun(user.companyId)) return

  return <OktaUserSearch />
}

export const Route = createFileRoute('/sunrun_/oktaUsers/')({
  component: SunrunOktaUsersPage,
})
